import "./App.css";
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Contact from "./Pages/Contact";
import NavigatBar from "./Components/NavigatBar";
import Gallery from "./Pages/Gallery";
import NewsandEvents from "./Pages/NewsandEvents";
import ClientsPartners from "./Pages/ClientsPartners";
import WhoWeAre from "./AboutUs/WhoWeAre";
import WhatWeDo from "./AboutUs/WhatWeDo";
import AgriculturalManagement from "./ThematicAreas/AgriculturalManagement";
import OurStaff from "./Team/OurStaff";
import BoardofDirectors from "./Team/BoardofDirectors";
import Footer from "./Components/Footer";
import CookstoveTesting from "./Services/CookstoveTesting";
import PublicHealth from "./ThematicAreas/PublicHealth";
import SustainableEnergy from "./ThematicAreas/SustainableEnergy";
import WaterSanitation from "./ThematicAreas/WaterSanitation";
import WasteManagement from "./ThematicAreas/WasteManagement";
import CapacityBuilding from "./Services/CapacityBuilding";
import Consultancy from "./Services/Consultancy";
import MonitoringEvaluation from "./Services/MonitoringEvaluation";
import Research from "./Services/Research";
import AlexanderAtuyamba from "./Profiles/AlexanderAtuyamba";
import AranAhereza from "./Profiles/AranAhereza";
import BernardByamukama from "./Profiles/BernardByamukama";
import DavisKintu from "./Profiles/DavisKintu";
import DenisMuhangi from "./Profiles/DenisMuhangi";
import EuniceKyomuhendo from "./Profiles/EuniceKyomuhendo";
import FredIsabirye from "./Profiles/FredIsabirye";
import GodfreyMuhwezi from "./Profiles/GodfreyMuhwezi";
import GoodchildIsingomaYonah from "./Profiles/GoodchildIsingomaYonah";
import HasifaNamugabo from "./Profiles/HasifaNamugabo";
import IsaacAhimbisiibwe from "./Profiles/IsaacAhimbisiibwe";
import JosephNdemereArineitwe from "./Profiles/JosephNdemereArineitwe";
import JulietKyayesimira from "./Profiles/JulietKyayesimira";
import KennethArinaitwe from "./Profiles/KennethArinaitwe";
import LivingstoneKilwa from "./Profiles/LivingstoneKilwa";
import PatriciaNyansheegu from "./Profiles/PatriciaNyansheegu";
import PatrickWaweyo from "./Profiles/PatrickWaweyo";
import CarolGabeya from "./Profiles/CarolGabeya";
import RashidSeggujja from "./Profiles/RashidSeggujja";
import LabNewsFeed1 from "./NewsPages/LabNewsFeed1";
import TrainingBriquetteCookstove from "./NewsPages/TrainingBriquetteCookstove";
import TestingBioLiteCookstoves from "./NewsPages/TestingBioLiteCookstoves";
import Lab2Field from "./NewsPages/Lab2Field";
import WorldWetlandsDay from "./NewsPages/WorldWetlandsDay";
import AgriculturalOfficeLandscape from "./NewsPages/AgriculturalOfficeLandscape";
import SensitizationValidationWorkshop from "./NewsPages/SensitizationValidationWorkshop";
import AdvancingStandardsCleanCooking from "./NewsPages/AdvancingStandardsCleanCooking";
import SKACSTraining from "./NewsPages/SKACSTraining";
import UgandaEfficientStoveProgram from "./NewsPages/UgandaEfficientStoveProgram";
import NationalECookingStrategy from "./NewsPages/Nationalecookingstrategy";
import TOTBriquettePELUM from "./NewsPages/Totbriquettepelum";
import { BaselineFuelConsumption } from "./NewsPages/BaselineFuelConsumption";
import { BerkeleyAirMonitoring } from "./NewsPages/BerkeleyAirMonitoring";
import { ImpactCarbonGoldStandard } from "./NewsPages/ImpactCarbonGoldStandar";
import { NovelSalesPilot } from "./NewsPages/NovelSalesPilot";
import { ENABELBriquetraining } from "./NewsPages/ENABELBriquetraining";
import { EnergyAccessKasese } from "./NewsPages/EnergyAccessKasese";
import { GVEPInstitutionalStoves } from "./NewsPages/GVEPInstitutionalStoves";
import { HouseholdECookingStudy } from "./NewsPages/HouseholdECookingStudy";
import { ImpactCarbon2023 } from "./NewsPages/ImpactCarbon2023";
import { ImpactWaterMonitoring } from "./NewsPages/ImpactWaterMonitoring";
import { InHomeGHGEmissions } from "./NewsPages/InHomeGHGEmissions";
import { InstitutionalNeedsAssessment } from "./NewsPages/InstitutionalNeedsAssessment";
import { KFDConsumerTesting } from "./NewsPages/KFDConsumerTesting";
import { KPTTrainingKenya } from "./NewsPages/KPTTrainingKenya";
import { LIRA2030 } from "./NewsPages/LIRA2030";
import { MECSSchoolsECooking } from "./NewsPages/MECSSchoolsECooking";
import { MbaleBaselineHIVOS } from "./NewsPages/MbaleBaselineHIVOS";
import { MtElgonFeasibility } from "./NewsPages/MtElgonFeasibility";
import { NationalCharcoalSurvey } from "./NewsPages/NationalCharcoalSurvey";
import { PSFUPolicyBrief } from "./NewsPages/PSFUPolicyBrief";
import { SNVMarketIntelligence } from "./NewsPages/SNVMarketIntelligence";
import { SmallPoAMonitoring } from "./NewsPages/SmallPoAMonitoring";
import { UCCSCEPMonitoring } from "./NewsPages/UCCSCEPMonitoring";
import { UpEnergyMonitoring } from "./NewsPages/UpEnergyMonitoring";
import { WTPConsumerAcceptance } from "./NewsPages/WTPConsumerAcceptance";
import { WWFMidTermReview } from "./NewsPages/WWFMidTermReview";
import { AfricanBiogasCarbon } from "./NewsPages/AfricanBiogasCarbon";
import { AlbertineEnergyPlanning } from "./NewsPages/AlbertineEnergyPlanning";
import { AruaMasindiBaseline } from "./NewsPages/AruaMasindiBaseline";
import { BehaviouralChangeMbarara } from "./NewsPages/BehaviouralChangeMbarara";
import { BEIAProject } from "./NewsPages/BEIAProject";
import { BiodigesterBusinessCase } from "./NewsPages/BiodigesterBusinessCase";
import { BioLiteGoldStandard } from "./NewsPages/BioLiteGoldStandard";
import { ClimateSecureBaseline } from "./NewsPages/ClimateSecureBaseline";
import { CO2balanceUganda } from "./NewsPages/CO2balanceUganda";
import { DutchSparkBaseline } from "./NewsPages/DutchSparkBaseline";
import { ECookingBaselineStrategy } from "./NewsPages/ECookingBaselineStrategy";
import { ECOTanzania } from "./NewsPages/ECOTanzania";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./Components/ScrollToTop";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div>
          <NavigatBar />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/contact-us" component={Contact} />
            <Route path="/publicity/gallery" component={Gallery} />
            <Route
              path="/publicity/news-and-events"
              component={NewsandEvents}
            />
            <Route
              path="/about-us/our-clients-partners"
              component={ClientsPartners}
            />
            <Route path="/about-us/who-we-are" component={WhoWeAre} />
            <Route
              path="/our-thematic-areas/public-health"
              component={PublicHealth}
            />
            <Route
              path="/our-thematic-areas/energy"
              component={SustainableEnergy}
            />
            <Route
              path="/our-thematic-areas/water-and-sanitation"
              component={WaterSanitation}
            />
            <Route
              path="/our-thematic-areas/waste-management"
              component={WasteManagement}
            />
            <Route
              path="/our-thematic-areas/agricultural-management"
              component={AgriculturalManagement}
            />
            <Route path="/the-team/the-staff-team" component={OurStaff} />
            <Route
              path="/the-team/top-management"
              component={BoardofDirectors}
            />
            <Route
              path="/our-services/cookstoves-and-fuel-testing"
              component={CookstoveTesting}
            />
            <Route path="/about-us/what-we-do" component={WhatWeDo} />
            <Route
              path="/our-services/capacity-building"
              component={CapacityBuilding}
            />
            <Route path="/our-services/consultancy" component={Consultancy} />
            <Route
              path="/our-services/monitoring-and-evaluation"
              component={MonitoringEvaluation}
            />
            <Route path="/our-services/research" component={Research} />
            <Route path="/alexander-atuyamba" component={AlexanderAtuyamba} />
            <Route path="/aran-ahereza" component={AranAhereza} />
            <Route path="/bernard-byamukama" component={BernardByamukama} />
            <Route path="/davis-kintu" component={DavisKintu} />
            <Route path="/denis-muhangi" component={DenisMuhangi} />
            <Route path="/eunice-kyomuhendo" component={EuniceKyomuhendo} />
            <Route path="/fred-isabirye" component={FredIsabirye} />
            <Route path="/godfrey-muhwezi" component={GodfreyMuhwezi} />
            <Route
              path="/goodchild-isingoma-yonah"
              component={GoodchildIsingomaYonah}
            />
            <Route path="/hasifa-namugabo" component={HasifaNamugabo} />
            <Route path="/isaac-ahimbisiibwe" component={IsaacAhimbisiibwe} />
            <Route
              path="/joseph-ndemere-arineitwe"
              component={JosephNdemereArineitwe}
            />
            <Route path="/juliet-kyayesimira" component={JulietKyayesimira} />
            <Route path="/kenneth-arinaitwe" component={KennethArinaitwe} />
            <Route path="/livingstone-kilwa" component={LivingstoneKilwa} />
            <Route path="/patricia-nyansheegu" component={PatriciaNyansheegu} />
            <Route path="/patrick-waweyo" component={PatrickWaweyo} />
            <Route path="/carol-gabeya" component={CarolGabeya} />
            <Route path="/rashid-seggujja" component={RashidSeggujja} />
            <Route
              path="/From-Lab-to-Field-Advancing-Regional-Collaboration-in-Clean-Cooking"
              component={Lab2Field}
            />
            <Route
              path="/Celebrating-World-Wetlands-Day"
              component={WorldWetlandsDay}
            />
            <Route
              path="/Agricultural-Thematic-Area-Changing-the-Office-Landscape"
              component={AgriculturalOfficeLandscape}
            />
            <Route
              path="/Sensitization-and-Validation-Workshop-on-National-Standards-for-Institutional-Cookstoves-and-Institutional-Biogas-Systems"
              component={SensitizationValidationWorkshop}
            />
            <Route
              path="/Advancing-Standards-for-Clean-Cooking-in-Uganda"
              component={AdvancingStandardsCleanCooking}
            />
            <Route
              path="/Training-in-Progress-Schools-Kitchen-and-Cooking-Study-SKACS-Project-Uganda"
              component={SKACSTraining}
            />
            <Route
              path="/Third-Party-Independent-Monitoring-for-the-Uganda-Energy-Efficient-Stoves-Programme-Impact-Carbon"
              component={ImpactCarbonGoldStandard}
            />
            <Route
              path="/Monitoring-for-Uganda-Energy-Efficient-Stoves-Berkeley-Air-Monitoring-Group"
              component={BerkeleyAirMonitoring}
            />
            <Route
              path="/Baseline-Fuel-Consumption-Study-Gulu-Mbarara-and-Kampala"
              component={BaselineFuelConsumption}
            />
            <Route
              path="/Provision-of-Training-in-Bio-Briquette-Production-West-Nile-Karamoja-and-Rwenzori-Regions-ENABEL"
              component={ENABELBriquetraining}
            />
            <Route
              path="/Energy-Access-Baseline-Study-Kasese-District"
              component={EnergyAccessKasese}
            />
            <Route
              path="/Testing-of-Institutional-Improved-Cookstoves-GVEP-International-CARE-Project"
              component={GVEPInstitutionalStoves}
            />
            <Route
              path="/Household-eCooking-Study-Energy-Implications-of-Cooking-Entirely-with-Electricity"
              component={HouseholdECookingStudy}
            />
            <Route
              path="/Gold-Standard-PoA-Monitoring-Impact-Carbon-2023"
              component={ImpactCarbon2023}
            />
            <Route
              path="/Gold-Standard-PoA-Monitoring-Impact-Water"
              component={ImpactWaterMonitoring}
            />
            <Route
              path="/In-Home-Greenhouse-Gas-Emissions-Testing-Rocket-and-Traditional-Stoves-Ruhiira-Uganda"
              component={InHomeGHGEmissions}
            />
            <Route
              path="/Clean-Cooking-Energy-Needs-Assessment-Public-and-Private-Institutions-MEMD-World-Bank"
              component={InstitutionalNeedsAssessment}
            />
            <Route
              path="/Consumer-Testing-of-Key-Fact-Documents-for-Cookstoves-GIZ-Uganda"
              component={KFDConsumerTesting}
            />
            <Route
              path="/KPT-Training-Support-Kenya-and-Cambodia-Berkeley-Air-Monitoring-Group-2025"
              component={KPTTrainingKenya}
            />
            <Route
              path="/Leading-Integrated-Research-for-Agenda-2030-in-Africa-LIRA-2030-Indoor-Air-Quality-Study"
              component={LIRA2030}
            />
            <Route
              path="/CIRCODU-Laboratory-a-Leader-in-Testing-Cookstoves-for-Efficiency-Safety-Durability-and-Emissions"
              component={LabNewsFeed1}
            />
            <Route
              path="/MECS-Uganda-Schools-eCooking-Programme-Transitioning-Schools-from-Biomass-to-Electric-Cooking"
              component={MECSSchoolsECooking}
            />
            <Route
              path="/Baseline-Study-Social-Cultural-and-Economic-Conditions-in-Rural-Mbale-HIVOS-Clean-Air-Zone-Uganda"
              component={MbaleBaselineHIVOS}
            />
            <Route
              path="/Feasibility-Assessment-for-an-Improved-Cookstoves-Carbon-Offset-Project-Mt-Elgon-Region"
              component={MtElgonFeasibility}
            />
            <Route
              path="/National-Charcoal-Survey-for-Uganda"
              component={NationalCharcoalSurvey}
            />
            <Route
              path="/Uganda-Moves-Towards-Efficient-Use-of-Electricity-for-Cooking-A-National-eCooking-Strategy-Takes-Shape"
              component={NationalECookingStrategy}
            />
            <Route
              path="/Novel-Sales-Pilot-Study-University-of-California-Berkeley-and-Innovations-for-Poverty-Action"
              component={NovelSalesPilot}
            />
            <Route
              path="/Policy-Brief-Energy-Efficiency-Opportunities-in-Agri-Business-Value-Chains-PSFU"
              component={PSFUPolicyBrief}
            />
            <Route
              path="/Market-Intelligence-Study-for-the-Improved-Cookstove-Subsector-in-Uganda-SNV"
              component={SNVMarketIntelligence}
            />
            <Route
              path="/Gold-Standard-PoA-Monitoring-Supporting-Ugandas-Emerging-Clean-Cooking-Enterprises"
              component={SmallPoAMonitoring}
            />
            <Route
              path="/Testing-of-BioLite-Cookstoves-at-the-CIRCODU-Cookstove-Laboratory"
              component={TestingBioLiteCookstoves}
            />
            <Route
              path="/Training-of-Trainers-on-Briquette-and-Energy-Efficient-Cookstove-Production-for-PELUM-Uganda-Affiliates"
              component={TOTBriquettePELUM}
            />
            <Route
              path="/Training-Services-on-Briquette-and-Cookstove-Production-to-PELUM-Uganda-affiliated-smallholder-farmers"
              component={TrainingBriquetteCookstove}
            />
            <Route
              path="/Independent-Verification-and-Results-Monitoring-Uganda-Clean-Cooking-Supply-Chain-Expansion-Project-UCCSCEP"
              component={UCCSCEPMonitoring}
            />
            <Route
              path="/Third-Party-Independent-Monitoring-and-Evaluation-for-the-Uganda-Efficient-Stove-Program"
              component={UgandaEfficientStoveProgram}
            />
            <Route
              path="/Monitoring-for-Improved-Cookstove-Carbon-Projects-UpEnergy-2011-Ongoing"
              component={UpEnergyMonitoring}
            />
            <Route
              path="/Willingness-to-Pay-and-Consumer-Acceptance-Assessment-for-Clean-Cooking-in-Uganda-World-Bank"
              component={WTPConsumerAcceptance}
            />
            <Route
              path="/Mid-Term-Review-Renewable-Energy-Projects-Energy-Climate-and-Extractives-Programme-WWF-Uganda"
              component={WWFMidTermReview}
            />
            <Route
              path="/Carbon-Monitoring-and-Biogas-User-Surveys-African-Biogas-Carbon-Programme"
              component={AfricanBiogasCarbon}
            />
            <Route
              path="/Supporting-20-District-Local-Governments-on-District-Level-Energy-Planning-Albertine-Graben"
              component={AlbertineEnergyPlanning}
            />
            <Route
              path="/Socio-Economic-Study-and-Energy-Access-Baseline-Arua-and-Masindi-Districts"
              component={AruaMasindiBaseline}
            />
            <Route
              path="/Behavioural-Change-Interventions-in-Cookstove-Adoption—Mbarara-District"
              component={BehaviouralChangeMbarara}
            />
            <Route
              path="/Biomass-Energy-Initiative-for-Africa-BEIA-TLUD-Gasifier-Stove-Study-Uganda"
              component={BEIAProject}
            />
            <Route
              path="/Assessment-of-Business-Case-for-Household-Bio-Digesters-Uganda-BSUL"
              component={BiodigesterBusinessCase}
            />
            <Route
              path="/Gold-Standard-PoA-Monitoring-BioLite-Cookstoves"
              component={BioLiteGoldStandard}
            />
            <Route
              path="/Baseline-Study-and-KPT-Survey—Improved-Cookstoves-and-Water-Treatment-Filters-Climate-Secure-India"
              component={ClimateSecureBaseline}
            />
            <Route
              path="/Baseline-KPT-Surveys-CO2balance-Uganda"
              component={CO2balanceUganda}
            />
            <Route
              path="/Baseline-Study-on-Pre-Project-Fuel-Consumption-Dutch-Spark-for-Clean-Cooking-Solutions"
              component={DutchSparkBaseline}
            />
            <Route
              path="/eCooking-Baseline-Study-and-National-eCooking-Strategy-for-Uganda"
              component={ECookingBaselineStrategy}
            />
            <Route
              path="/Monitoring-for-International-Energy-Investment-Organisation-E+CO-Cookstove-Programme-Tanzania"
              component={ECOTanzania}
            />
          </Switch>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
